/**
 * Cruise Command · single-source-of-truth version metadata.
 *
 * Governance directive (2026-07-15) established Cruise Command 1.0 RC1
 * as the first named release intended for users outside the development
 * team. All previous internal versions (0.x · internal 2.x · internal
 * 3.x) are engineering history — see /app/memory/RELEASE_HISTORY.md.
 *
 * 2026-07-22 · RC2 MXR Release Qualification bump. Persistence Integrity
 * Certification PASSED, MXR audit completed with fixes; ready for the
 * MXR Release Gate → RC3 transition.
 *
 * Update this file (and this file only) to change every visible version
 * reference across the app.
 */
export const VERSION_META = Object.freeze({
  productName: "Cruise Command",
  version:     "1.0",
  build:       "RC2",
  status:      "Release Candidate 2",
  state:       "Persistence & Release Qualification · MXR PASS",
  channel:     "Family & Friends · Early Adopters",
  releasedAt:  "2026-07-22",
  legalYear:   new Date().getFullYear(),
  tagline:     "Voyage Intelligence.",
  codename:    "Publication",
});

export const VERSION_LINE = `${VERSION_META.productName} ${VERSION_META.version} ${VERSION_META.build}`;
